import React from 'react'
import { createUseStyles } from "react-jss";



export default function MzRoundedBox({className,style, children,onClick, ...otherProps}) {
  const st = styles();
  
  const pointerClass = onClick && st.pointer;
  
  return (
    <div onClick={()=>onClick && onClick() } className={className+" "+st.container+" "+pointerClass} style={style} {...otherProps}>
        {children}
    </div>
  )
}



const styles = createUseStyles({

  pointer:{
    cursor: "pointer"
  },

  container: {
      border: "1px solid gray",
      borderRadius:"15px",
      padding:"0.5rem",
      overflow:"hidden",
     // marginBottom:"1rem",
      width: "fit-content"
  },

});